import { render, staticRenderFns } from "./CharactersClasses.vue?vue&type=template&id=45f08ec2&lang=pug&"
import script from "./CharactersClasses.vue?vue&type=script&lang=ts&"
export * from "./CharactersClasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
